import Cookies from "js-cookie";
import { LOGIN, SIGN_UP } from "@/constants/Query";
import { axiosInstanceSend } from "./axiosConfigSend";

export async function apiRequestSendGe(
  url: string,
  method: "get" | "put" | "post" | "delete",
  data?: object,
  headers: any = {},
) {
  const token = Cookies.get("sendToken") || null;

  if (token) {
    axiosInstanceSend.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  const requestConfig: any = {
    url,
    method,
    headers:
      url !== LOGIN && url !== SIGN_UP
        ? headers
        : { ...headers, Authorization: "Bearer" },
  };

  if (method.toLocaleLowerCase() === "get") {
    const queryParams = new URLSearchParams();

    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            queryParams.append(`${key}[${index}]`, item.toString());
          });
        } else if (value !== null && value !== undefined) {
          queryParams.append(key, value.toString());
        }
      });
    }

    requestConfig.params = queryParams;
  } else if (
    method.toLocaleLowerCase() === "post" ||
    method.toLocaleLowerCase() === "put" ||
    method.toLocaleLowerCase() === "delete"
  ) {
    requestConfig.data = data;
  }

  return axiosInstanceSend(requestConfig);
}
